export default {
      id: "files-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#files",
      toString: function () {
        return this.url;
      }
    }